module.exports = __webpack_public_path__ + "img/airplane.e47e8b62.png";